module.exports = __webpack_public_path__ + "static/media/Boat_1.d74a60da.png";